export function getAnswers() {
  return {
    yes: { id: "yes", name: "Sim" },
    no: { id: "no", name: "Não" },
    mol: { id: "mol", name: "Mais ou menos" },
    idk: { id: "idk", name: "Não sei" }
  };
}
export function getBinaryAnswers() {
  return {
    yes: { id: "yes", name: "Sim" },
    no: { id: "no", name: "Não" }
  };
}

export function getNumericalAnswers() {
  return {
    1: { id: 1, name: "1 - Muito mau" },
    2: { id: 2, name: "2 - Mau" },
    3: { id: 3, name: "3 - Mais ou menos" },
    4: { id: 4, name: "4 - Bom" },
    5: { id: 5, name: "5 - Muito bom" }
  };
}
